import { useCallback } from "react";
import { stringify } from "query-string";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";

export default function () {
  const { request } = useApi();

  return {
    fetchBillingStudentNames: useCallback(
      (filter: { schoolId?: string; agentId?: string; parentId?: string }) => {
        return request({
          method: "GET",
          url: ApiRoutes.GET_BILLING_STUDENTS_NAMES + stringify(filter),
          shouldHandleError: true,
        });
      },
      [request],
    ),

    fetchBillingStudentCountries: useCallback(
      (filter: { schoolId?: string; agentId?: string; parentId?: string }) => {
        return request({
          method: "GET",
          url: ApiRoutes.GET_BILLING_STUDENTS_COUNTRIES + stringify(filter),
          shouldHandleError: true,
        });
      },
      [request],
    ),

    fetchBillingReceipts: useCallback(
      (filter: {
        schoolId?: string;
        agentId?: string;
        parentId?: string;
        studentId?: string;
        isForStudent?: boolean;
      }) => {
        return request({
          method: "GET",
          url: ApiRoutes.GET_BILLING_RECEIPTS + stringify(filter),
          shouldHandleError: true,
        });
      },
      [request],
    ),

    fetchCredits: useCallback(() => {
      return request({
        method: "GET",
        url: ApiRoutes.MY_ACCOUNT_PACKAGE,
      });
    }, [request]),
  };
}
